import React from 'react';

import './ResaleOfferPortalErrorStyle.less';

const ResaleOfferPortalPage: React.SFC = () => (
  <div className="od-rop-error-page">
    <p>
      Please <a href="/make-offer">retry</a> or submit your offer via{' '}
      <a href="mailto:homes@opendoor.com">homes@opendoor.com</a>
    </p>
    <img src="/error/door-error-500.svg" className="door" />
  </div>
);

export default ResaleOfferPortalPage;
